<div class="flex-horizontal">
  <div class="stepper flex-vertical gap-56 background-white">
    <h5>{{ stepperTitle }}</h5>
    @if (proxeemaOperationUrl) {
      <a [href]="proxeemaOperationUrl" target="_blank" rel="noopener noreferrer">Ouvrir l'opération Proxeema</a>
    }
    <oui-stepper
      [steps]="steps"
      [displayNumbers]="false"
      direction="vertical"
      (currentStepChange)="onStepChange($event)"
    #stepper></oui-stepper>
  </div>
  <div class="content contain">
    @if (isLoading) {
      <div>
        <oui-loading class="loadingCenterItem"></oui-loading>
      </div>
    } @else {
      <div class="flex-vertical background-white width-100pc oui-elevation-04 padding-32 gap-32 card">
        <div class="flex-vertical gap-8">
          <h6>{{ this.stepper?.currentStep?.title }}</h6>
          @if (
            !draftOperationsService.operationGroupData.contrat && stepper?.currentStep?.title == CONTRAT_STEP_TITLE
            ) {
            <div
              class="body-2"
              >
              Sélectionnez un contrat
            </div>
          }
        </div>
        @if (!isActiveHabilitation) {
          <oui-banner
            title="Vous n'avez aucune habilitation active en placement"
            declination="error"
          [action]="noHabilAction"></oui-banner>
        }
        @if (this.stepper?.currentStep?.title == CONTRAT_STEP_TITLE) {
          <app-contrat-selector
            (onContratSelection)="onContratSelected($event)"
            [contratId]="$safeNavigationMigration(draftOperationsService.operationGroupData.contrat?.id)!"
          [isModifierDisabled]="!!draftOperationsService.operationGroupData.id"></app-contrat-selector>
        }
        @if (this.stepper?.currentStep?.title == INVESTISSEUR_STEP_TITLE) {
          <app-investisseur-step-declaration #investisseurCmp></app-investisseur-step-declaration>
        }
        @if (this.stepper?.currentStep?.title == INFORMATION_STEP_TITLE) {
          <app-step-informations #stepInfosCmp></app-step-informations>
        }
        @if (this.stepper?.currentStep?.title == FILE_STEP_TITLE) {
          <app-operation-group-files-configuration #operationGroupFilesConfiguration>
          </app-operation-group-files-configuration>
        }
      </div>
    }
  </div>
</div>
<app-stepper-footer
  [isNextStepDisabled]="false"
  [previousStepButtonText]="previousLabel"
  [nextStepButtonText]="ctaLabel"
  [nextStepButtonIcon]="isLastStep"
  [isSaveDisplayed]="isSaveButtonDisplayed()"
  (nextStepClicked)="onNextStepClick()"
  (previousStepClicked)="onPreviousStepClick()"
  [nextStepFullActive]="nextStepButtonActivity()"
  [nextStepWithArrow]="!isLastStep"
  (saveAndExitClicked)="onSaveAndExit()">
</app-stepper-footer>
